
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { required, minLength, sameAs } from '@vuelidate/validators';
import { accountService } from './AccountService';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
  name: 'ChangePassword',
  mixins: [Form],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
    };
  },
  validations() {
    return {
      form: {
        oldPassword: { required },
        newPassword: { required, minLength: minLength(8) }, // https://jsfiddle.net/sg2zd9mf/
        confirmPassword: { required, sameAsPassword: sameAs(this.form.newPassword) },
      },
    };
  },
  methods: {
    async send() {
      if (!this.validate()) return;

      try {
        await accountService.changePassword(this.form);
        this.success();
      } catch (error) {
        this.handleApiError(error);
      }
    },
  },
});
